import {
  GetFrontRichiesteIdTipiComunicazioneTipo,
  useGetFrontRichiesteIdTipiComunicazione,
} from '@framework/api-client';

export function useFrontofficeCommunicationsTypes(
  submissionId: string | null | undefined,
) {
  const { data: sendableTypes } = useGetFrontRichiesteIdTipiComunicazione(
    submissionId!,
    {
      ordinaPerCodice: true,
      tipo: GetFrontRichiesteIdTipiComunicazioneTipo.INVIABILE,
    },
    { query: { enabled: submissionId != null, keepPreviousData: true } },
  );

  const { data: receivableTypes } = useGetFrontRichiesteIdTipiComunicazione(
    submissionId!,
    {
      ordinaPerCodice: true,
      tipo: GetFrontRichiesteIdTipiComunicazioneTipo.RICEVIBILE,
    },
    { query: { enabled: submissionId != null, keepPreviousData: true } },
  );

  // Tipi comunicazione ricercabili
  const { data: searchableTypes } = useGetFrontRichiesteIdTipiComunicazione(
    submissionId!,
    {
      ordinaPerCodice: true,
      tipo: GetFrontRichiesteIdTipiComunicazioneTipo.RICERCABILE,
    },
    { query: { enabled: submissionId != null } },
  );

  return { sendableTypes, receivableTypes, searchableTypes };
}
